(function($) {
    $('document').ready(function() {
        const seasonPassType = $('select#season-pass-type');
        if (seasonPassType.length === 0) {
            return;
        }

        const addToCartButton = $('button.single_add_to_cart_button');

        const seasonPassPriceContainer = $('div.season-pass-price-container');
        const seasonPassPrice = $('span#season-pass-price');

        const seasonPassQuantity = $('input#season-pass-quantity');

        let selectedProductId = null;
        let selectedProductQuantity = null;

        const setPrice = function(price) {
            seasonPassPrice.html(price);
            seasonPassPriceContainer.show();
            if (!addToCartButton.hasClass('full-cart')) {
                addToCartButton.removeClass('disabled');
            }
        }

        const handlePassSelection = function() {
            selectedProductId = seasonPassType.val();
            if (selectedProductQuantity === null) {
                seasonPassPriceContainer.hide();
                addToCartButton.addClass('disabled');
                return;
            }

            addToCartButton.attr('value', selectedProductId);
            const price = $('input.season-pass-price[data-id="'+selectedProductId+'"]').data('price');
            setPrice(price*selectedProductQuantity);
        }
        handlePassSelection()
        seasonPassType.change(handlePassSelection)

        const handlePassQuantity = function() {
            selectedProductQuantity = seasonPassQuantity.val();
            if (selectedProductId === null) {
                seasonPassPriceContainer.hide();
                addToCartButton.addClass('disabled');
                return;
            }

            const price = $('input.season-pass-price[data-id="'+selectedProductId+'"]').data('price');
            setPrice(price*selectedProductQuantity);
        }
        handlePassQuantity()
        seasonPassQuantity.change(handlePassQuantity)

        const submitForm = function(e) {
            if ($(this).hasClass('disabled')) {
                e.preventDefault();
                return;
            }
            $('form#checkout').submit();
        };
        addToCartButton.click(submitForm);
    });
})(jQuery);